import React from "react";
import { Typography, Card, Box, Grid } from "@mui/material";
import { styled } from "@mui/system";
import ViewButton from "../Famer/ViewButton";

const StyledDetailsCard = styled(Card)({
  border: "1px solid #A5A5A5",
  marginBottom: "10px",
});

const DetailsCardContent = styled(Box)({
  padding: "10px",
});

const CustomDetailedList = ({ data, buttonList }) => {
  return (
    <StyledDetailsCard>
      <DetailsCardContent>
        <Grid container>
          {data.map(({ label, value }, index) => (
            <>
              <Grid display="flex" style={{ paddingLeft: "8px" }} item xs={12}>
                <Grid item xs={6}>
                  <Typography
                    key={index}
                    variant="body1"
                    style={{ color: "#443F3F" }}
                    align="left"
                  >
                    {label}:
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography
                    key={index}
                    variant="body1"
                    style={{
                      color: "#000000",
                      marginLeft: "8px",
                      wordBreak: "break-word",
                    }}
                    align="left"
                  >
                    {value}
                  </Typography>
                </Grid>
              </Grid>
            </>
          ))}
          <div style={{ marginTop: "40px" }}></div>

          {buttonList && (
            <>
              {buttonList.map((button, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ViewButton label={button} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </DetailsCardContent>
    </StyledDetailsCard>
  );
};

export default CustomDetailedList;
